import { useOperations } from "./useOperations";
import type { OperationRequest, OperationStore } from "./operationStore";

/** Subscribe for presentation, but check the live store when an action is invoked. */
export function useResourceOperation(store: OperationStore, resources: readonly string[]) {
  const entries = useOperations(store);
  const entry = entries.find(value => value.resources.some(resource => resources.includes(resource)));
  return {
    entry,
    blocked: Boolean(entry),
    pending: Boolean(entry && entry.phase !== "refreshFailed"),
    canStart: () => store.isActive() && !store.conflicts(resources),
    execute: (request: Omit<OperationRequest, "resources">) => store.execute({ ...request, resources }),
    retry: async () => { if (entry) await store.retry(entry.id); },
  };
}
